import styled,{default as _styled,default as _styled2,default as _styled3}from'styled-components';import*as Tabs from"../../common/tabs";import FlexCenter from"../../shared/FlexCenter";import{MEDIA}from"../../../features/layout/media-queries";import{useTranslation}from"../../../features/localization/utils";import*as OrderFn from"../../../features/order/functions";import{useOrderFormActions,useOrderFormView}from"../../../features/perpetuals/order-builder/form-context";import{cCC38FF,cFFFFFF}from"../../../colors";import MarginSettings from"../margin-settings/MarginSettingsButton";import MarginSettingsButtonProvider from"../margin-settings/MarginSettingsButtonProvider";import ProOrderTypeSelect from"./ProOrderTypeSelect";import{jsx as _jsx,jsxs as _jsxs}from"react/jsx-runtime";var _StyledFlexCenter=_styled(FlexCenter)`flex: 1;`;var _StyledFlexCenter2=_styled2(FlexCenter)`justify-content: flex-start; flex: 1;`;export default function MobileOrderBuilderTabs(){const{t}=useTranslation();const formActions=useOrderFormActions();const formView=useOrderFormView();const handleTabChange=id=>{formActions.updateType(id);};return/*#__PURE__*/_jsxs(Container,{children:[/*#__PURE__*/_jsx(_StyledFlexCenter,{children:/*#__PURE__*/_jsx(MarginSettingsButtonProvider,{children:/*#__PURE__*/_jsx(MarginSettings,{})})}),/*#__PURE__*/_jsxs(_StyledFlexCenter2,{gap:6,children:[/*#__PURE__*/_jsx(_StyledTabsRoot,{value:formView.formType,onValueChange:handleTabChange,children:/*#__PURE__*/_jsxs(TabsList,{"aria-label":"Order Type",children:[/*#__PURE__*/_jsx(TabsItem,{value:"MARKET",children:t(OrderFn.typeToText('MARKET'))}),/*#__PURE__*/_jsx(TabsItem,{value:"LIMIT",children:t(OrderFn.typeToText('LIMIT'))})]})}),/*#__PURE__*/_jsx(ProOrderTypeSelect,{value:formView.formType,onValueChange:handleTabChange})]})]});}const Container=styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  justify-content: space-around;
`;const TabsRoot=/*#__PURE__*/styled(Tabs.Root)`
  display: flex;
  width: 100%;
  overflow: auto;
`;var _StyledTabsRoot=/*#__PURE__*/_styled3(TabsRoot).withConfig({displayName:"MobileOrderBuilderTabs___StyledTabsRoot",componentId:"sc-11fd4je-0"})(["grid-area:order-tabs"]);const TabsList=/*#__PURE__*/styled(Tabs.TabsList)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
  z-index: 1;
`;const TabsItem=/*#__PURE__*/styled(Tabs.TabsTrigger)`
  font-size: 0.875rem;
  height: 32px;
  flex: 1;
  opacity: 0.7;
  color: ${cFFFFFF};
  background-color: transparent;
  border: none;
  font-weight: 600;

  &[data-state='active'] {
    box-sizing: border-box;
    opacity: 1;
    border-bottom: 3px solid ${cCC38FF};
  }

  @media ${MEDIA.sm} {
    padding: 0;
  }
`;